<template>
  <jr-select
    class="line-select"
    :options="lines"
    :modelValue="modelValue"
    valueKey="line_code"
    labelKey="line_name"
    :popperAppendToBody="popperAppendToBody"
    @update:modelValue="update($event)"
    :disabled="disabled"
    :size="size"
    :isEdit="isEdit"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import JrSelect from '@/components/jr-parts/JrSelect.vue'
import { Line } from '@/api'
import { ListRequest } from '@/requests/line'

export default defineComponent({
  name: 'LineSelect',
  components: {
    JrSelect,
  },
  emits: ['update:modelValue', 'update:name'],
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null,
    },
    blank: {
      type: Boolean,
      required: false,
      default: true,
    },
    popperAppendToBody: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    nullable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  async setup(props, context) {
    const lines: Array<Line> = []

    if (props.blank) {
      // 空白の選択肢を付与する
      lines.push({
        line_code: '',
        line_name: ' ',
        line_sort: -1,
      })
    }

    // 一覧の取得
    const request = new ListRequest()
    await request.exec()
    if (request.success) {
      const { data } = request.getResponse() as AxiosResponse<Array<Line>>
      lines.push(...data)
    }

    return {
      lines,
      update: (code: string) => {
        // 選択したvalueを返す
        context.emit('update:modelValue', code === '' && props.nullable ? null : code)

        // コードから名前を検索
        const selectedOption = lines.find((line) => {
          return line.line_code === code
        })
        if (selectedOption != null && code !== '') {
          context.emit('update:name', selectedOption.line_name)
        } else {
          context.emit('update:name', '')
        }
      },
    }
  },
})
</script>
